import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login/Login";
import "./App.css";
import Signup from "./components/Signup/Signup";
import { Toaster } from 'react-hot-toast';
import Demo from "./pages/Demo";
import Register from "./pages/Register";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.getItem("isDarkMode") || false
  );

  // Disable developer tools on mount useEffect(() => { disableDevTools(); }, []);

  console.log("Patch update: May 8 10:40PM, 2026");

  const [email, setEmail] = useState(sessionStorage.getItem('email') || '');
  const [password, setPassword] = useState('');

  return (
    <Router>
      <Toaster 
        position="bottom-center"
        containerStyle={{
          zIndex: 99999
        }}
      />
      <Routes>
        <Route path="/login" element={<Login isDarkMode={isDarkMode} email={email} password={password} setEmail={setEmail} setPassword={setPassword} />} />
        <Route path="/signup" element={<Signup isDarkMode={isDarkMode} />} />
        <Route path="/demo" element={<Demo isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />} />
        <Route path="/register" element={<Register isDarkMode={isDarkMode} />} />
        <Route path="/*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
